import type { FC } from "react";
import { useTranslation } from "next-i18next";
import responsiveColumn from "../../../../methods/responsiveColumn";
import { Col, Row, Grid, Typography } from "antd";
import styles from "./style.module.scss";
import Image from "next/image";

export const ComplianceSection5: FC = () => {
  const { useBreakpoint } = Grid;
  const screenSize = useBreakpoint();
  const { t } = useTranslation("compliance");

  const lists = t("section5_unordered_list", {
    returnObjects: true,
  }) as string[];

  return (
    <Row
      style={{
        background: "#254486",
        padding: "80px 0 50px 0",
        color: "#fff",
      }}
      justify={"center"}
      className='stext3'
    >
      <Col
        style={{ textAlign: "center" }}
        {...responsiveColumn([16, 17, 18, 22, 22, 22])}
      >
        <h2
          className='section_title'
          style={{ fontSize: screenSize.md ? 48 : 24 }}
        >
          {t("section5_title")}
        </h2>
        <p style={{ fontSize: 16, textAlign: "center", lineHeight: 1.5 }}>
          {t("section5_p1")}
        </p>
        <p
          style={{
            fontSize: 16,
            textAlign: "center",
            lineHeight: 1.5,
            fontWeight: 700,
          }}
        >
          {t("section5_p2")}
        </p>
        <ul className={styles.ulStyle}>
          {lists &&
            lists.map((item, index) => (
              <Row gutter={[16, 16]} key={index} className={styles.rowWrapper}>
                <Col
                  {...responsiveColumn([2, 2, 1, 1, 1, 1])}
                  className={styles.imgColWrapper}
                >
                  <Image
                    src='/icons/material-symbols_square.svg'
                    width={24}
                    height={24}
                    alt='unordered list icon'
                    className={styles.imageContain}
                  />
                </Col>
                <Col
                  {...responsiveColumn([22, 22, 23, 23, 23, 23])}
                  className={styles.ulCol}
                >
                  <li>
                    <Typography.Text className={styles.liText}>
                      {item}
                    </Typography.Text>
                  </li>
                </Col>
              </Row>
            ))}
        </ul>
      </Col>
    </Row>
  );
};
